import { MdCheck } from "react-icons/md";

// The 18px square checkbox used across the settings modals and drawers.
//
// This markup was previously copy-pasted into four files (RoleUserSelectionModal,
// userselectmodal, RecipientsChipInput, MultiSelectChipInput) with none of them
// exporting it. Promoted here so the visual spec lives in one place.
//
// `onToggle` is optional: pass it when the tile itself is the click target and
// it renders a button that stops propagation. Omit it when the surrounding row
// already handles the click, and it renders an inert span so the two don't
// fight over the same event.
const CheckTile = ({ checked = false, indeterminate = false, disabled = false, onToggle, className = "" }) => {
  const filled = checked || indeterminate;
  const base = `w-[18px] h-[18px] rounded-[4px] border flex items-center justify-center shrink-0 overflow-hidden transition-colors ${
    filled ? "border-[#0065FD] bg-[#0065FD]" : "border-[#C9CEE2] bg-white"
  } ${disabled ? "opacity-45" : ""} ${className}`;

  const mark = checked ? (
    <MdCheck size={14} className="text-white" />
  ) : indeterminate ? (
    <span className="w-[8px] h-[2px] rounded-full bg-white" />
  ) : null;

  if (!onToggle) {
    return (
      <span aria-hidden="true" className={base}>
        {mark}
      </span>
    );
  }

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={indeterminate && !checked ? "mixed" : checked}
      disabled={disabled}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
      className={`${base} ${disabled ? "cursor-not-allowed" : ""}`}
    >
      {mark}
    </button>
  );
};

export default CheckTile;
